export default __webpack_public_path__ + "logo.0100437a.svg";